<template>
    <notifications-list></notifications-list>
</template>

<script>
import NotificationsList from "components/Notifications/NotificationsList";
export default {
    name: 'NotificationView',
    components: {
        NotificationsList
    }
}
</script>



// WEBPACK FOOTER //
// client/views/Notifications/Notifications.vue